import React from 'react'

import styled from '@emotion/styled'
import { mq } from '../../_style'
import BtnGroup from './btnGroup';
import HeadingSet from '../molecules/headingSet';
import Text from '../atoms/text';
import Br from '../atoms/br';
import InViewWrapper from './inViewWrapper';

const Container = styled.section`
  padding-bottom: 120px;
  ${props => props.withoutHead && `padding-bottom: 90px;`}
  ${props => props.inTop && `margin-top: 120px; padding-bottom: 0;`}
  ${mq.sp} {
    margin-top: 60px;
    padding-bottom: 60px;
  }
`

const TextContainer = styled.div`
  margin: 0 auto 60px;
  text-align: center;
  ${mq.pc} {
    max-width: 632px;
  }
  ${mq.sp} {
    padding: 0 20px;
    margin: 0 auto 60px;
  }
  & > p {
    padding-top: 30px;
  }
`
export default class SectionLineup extends React.Component {
  render() {
    return(
      <Container withoutHead={this.props.withoutHead} inTop={this.props.inTop}>
        <InViewWrapper isFadeIn>
          {!this.props.withoutHead &&
            <TextContainer>
              <HeadingSet en={'LINE UP'} isCenter>お口の悩みに<Br onlySp />選べるラインナップ</HeadingSet>
              <Text>お⼦様から⾼齢者の⽅まで。豊富なラインナップの中から、様々なお⼝の悩みに合わせて、最適な1本をお選びいただけます。</Text>
            </TextContainer>
          }
          <BtnGroup></BtnGroup>
        </InViewWrapper>
     </Container>
    )
  }
}
